import React from 'react';
import { motion } from 'framer-motion';
import { FaCertificate, FaAward } from 'react-icons/fa';
import './Certifications.css';

const certifications = [
  { code: 'CERT-01', name: 'LangChain: Chat with Your Data', issuer: 'DeepLearning.AI', year: '2024', badge: 'RAG' },
  { code: 'CERT-02', name: 'Build Chat Applications with OpenAI and LangChain', issuer: '365 DataScience', year: '2024', badge: 'LLMs' },
  { code: 'CERT-03', name: 'Machine Learning Engineer Certificate', issuer: 'DataCamp', year: '2024', badge: 'MLOps' },
  { code: 'CERT-04', name: 'Machine Learning Specialization', issuer: 'Coursera', year: '2024', badge: 'ML' },
  { code: 'CERT-05', name: 'Data Analyst Certificate', issuer: 'DataCamp', year: '2024', badge: 'Analytics' },
  { code: 'CERT-06', name: 'Data Engineering', issuer: 'DataCamp', year: '2024', badge: 'Pipelines' },
  { code: 'CERT-07', name: 'Data Scientist Certificate', issuer: 'DataCamp', year: '2024', badge: 'Data Science' },
  { code: 'CERT-08', name: 'AWS Specialization', issuer: 'Coursera', year: '2024', badge: 'Cloud' },
  { code: 'CERT-09', name: 'Natural Language Processing Specialization', issuer: 'Coursera', year: '2024', badge: 'NLP' },
  { code: 'CERT-10', name: 'Mathematics for Machine Learning', issuer: 'Coursera', year: '2024', badge: 'Math' },
  { code: 'CERT-11', name: 'Intermediate SQL', issuer: 'DataCamp', year: '2024', badge: 'Databases' },
];

const awards = [
  {
    name: 'XP Champ Award',
    issuer: 'DataCampXSunwaySRC',
    year: '2024',
    description: 'Recipient of [XP Champ Award], DataCampXSunwaySRC, 2024.',
  },
];

const Certifications = () => {
  return (
    <section id="certifications" className="certifications">
      <div className="container">
        <div className="section-header">
          <span className="section-label">[ 06 // VERIFIED CREDENTIALS ]</span>
          <h2 className="section-title">Certifications &amp; Honors</h2>
          <p className="section-subtitle">
            Professional certifications and recognitions earned across deep learning, generative AI, and data systems.
          </p>
        </div>

        {/* Awards */}
        <div className="certifications__awards">
          {awards.map((award, idx) => (
            <motion.div
              className="certifications__award-card"
              key={idx}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4 }}
            >
              <div className="certifications__award-icon">
                <FaAward />
              </div>
              <div className="certifications__award-content">
                <div className="certifications__award-top">
                  <h4 className="certifications__award-title">{award.name}</h4>
                  <span className="certifications__award-year">[{award.year}]</span>
                </div>
                <span className="certifications__award-issuer">{award.issuer}</span>
                <p className="certifications__award-desc">{award.description}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Certifications Grid */}
        <div className="certifications__grid">
          {certifications.map((cert, idx) => (
            <motion.div
              className="certifications__card"
              key={idx}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.03, duration: 0.35 }}
            >
              <div className="certifications__card-header">
                <span className="certifications__card-code">{cert.code}</span>
                <span className="certifications__card-badge">{cert.badge}</span>
              </div>
              <div className="certifications__card-body">
                <FaCertificate className="certifications__card-icon" />
                <div>
                  <h4 className="certifications__card-name">{cert.name}</h4>
                  <div className="certifications__card-meta">
                    <span className="certifications__card-issuer">{cert.issuer}</span>
                    <span className="certifications__card-dot">&bull;</span>
                    <span className="certifications__card-year">{cert.year}</span>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
